/*
 * サブシステム名：経営管理
 * 機能名：荷主別売上集計表
 */

import DdNumericBox from '@/components/DdNumericBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

export default {
  name: 'NinushiUriageKeiShukei',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    jishaUriageShukei: 0,
    yoshaUriageShukei: 0,
    uriageGokeiShukei: 0,
    enginePriceShukei: 0,
    hiwayPriceShukei: 0,
    humanPriceShukei: 0,
    shiharaiKingakuShukei: 0,
    genkaiRiekiShukei: 0,
    riekiRateShukei: 0,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1,
    isCsvDownloader: false,
    isPdfDownloader: false
  }),
  components: {
    DdNumericBox,
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdCodeTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdDateBox
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.jishaUriageKeiDisp = elem.jishaUriageKei === 0 || elem.jishaUriageKei ? filter.numericFormatter(elem.jishaUriageKei) : null
        elem.yoshaUriageKeiDisp = elem.yoshaUriageKei === 0 || elem.yoshaUriageKei ? filter.numericFormatter(elem.yoshaUriageKei) : null
        elem.uriageGokeiDisp = filter.numericFormatter(parseInt(elem.jishaUriageKei, 10) + parseInt(elem.yoshaUriageKei, 10))
        elem.enginePriceKeiDisp = elem.enginePriceKei === 0 || elem.enginePriceKei ? filter.numericFormatter(elem.enginePriceKei) : null
        elem.hiwayPriceKeiDisp = elem.hiwayPriceKei === 0 || elem.hiwayPriceKei ? filter.numericFormatter(elem.hiwayPriceKei) : null
        elem.humanPriceKeiDisp = elem.humanPriceKei === 0 || elem.humanPriceKei ? filter.numericFormatter(elem.humanPriceKei) : null
        elem.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === 0 || elem.shiharaiKingakuKei ? filter.numericFormatter(elem.shiharaiKingakuKei) : null
        elem.genkaiRiekiDisp = elem.genkaiRieki === 0 || elem.genkaiRieki ? filter.numericFormatter(elem.genkaiRieki) : null
        elem.riekiRateDisp = elem.riekiRate === 0 || elem.riekiRate ? filter.numericMinorDigitFormatter(elem.riekiRate, 2) : null
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    isPdfButtonDisabled () {
      return this.rows.length === 0 || this.isPdfDownloader
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      loginEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('NinushiUriageKeiShukei.defineHeaderPromise')
            self.headers = [
              { text: '荷主コード', value: 'ninushiCd' },
              { text: '荷主先', value: 'ninushiNm' },
              { text: '自社売上', value: 'jishaUriageKeiDisp', align: 'end' },
              { text: '傭車売上', value: 'yoshaUriageKeiDisp', align: 'end' },
              { text: '売上合計', value: 'uriageGokeiDisp', align: 'end' },
              { text: '燃料代', value: 'enginePriceKeiDisp', align: 'end' },
              { text: '通行料', value: 'hiwayPriceKeiDisp', align: 'end' },
              { text: '人件費', value: 'humanPriceKeiDisp', align: 'end' },
              { text: '傭車支払', value: 'shiharaiKingakuKeiDisp', align: 'end' },
              { text: '限界利益', value: 'genkaiRiekiDisp', align: 'end' },
              { text: '利益率', value: 'riekiRateDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            var loginEigyoshoId = 0
            if (self.filteredEigyoshoList) {
              const loginEigyosho = self.filteredEigyoshoList.filter((elem) => {
                return elem.eigyoshoCd === self.loginEigyoshoCd
              })
              if (loginEigyosho.length !== 0) {
                loginEigyoshoId = loginEigyosho[0].id
              }
            }
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            const startYmdString = `${startDate.getFullYear()}/${('0' + (startDate.getMonth() + 1)).slice(-2)}/${('0' + (startDate.getDate())).slice(-2)}`
            const endYmdString = `${endDate.getFullYear()}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${('0' + (endDate.getDate())).slice(-2)}`
            self.conditions = {
              searchEigyoshoId: loginEigyoshoId,
              ninushiId: null,
              seikyuYoteiStartYmd: startYmdString,
              seikyuYoteiEndYmd: endYmdString
            }
            self.jishaUriageShukei = 0
            self.yoshaUriageShukei = 0
            self.uriageGokeiShukei = 0
            self.enginePriceShukei = 0
            self.hiwayPriceShukei = 0
            self.humanPriceShukei = 0
            self.shiharaiKingakuShukei = 0
            self.genkaiRiekiShukei = 0
            self.riekiRateShukei = 0
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('NinushiUriageKeiShukei.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('NinushiUriageKeiShukei.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('NinushiUriageKeiShukei.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('NinushiUriageKeiShukei.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCThbzmd0040/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          if (data.payload !== null && data.payload.length !== 0) {
            const sum = (acc, cur) => acc + cur
            self.jishaUriageShukei = data.payload.map(elem => elem.jishaUriageKei ?? 0).reduce(sum)
            self.yoshaUriageShukei = data.payload.map(elem => elem.yoshaUriageKei ?? 0).reduce(sum)
            self.uriageGokeiShukei = self.jishaUriageShukei + self.yoshaUriageShukei
            self.enginePriceShukei = data.payload.map(elem => elem.enginePriceKei ?? 0).reduce(sum)
            self.hiwayPriceShukei = data.payload.map(elem => elem.hiwayPriceKei ?? 0).reduce(sum)
            self.humanPriceShukei = data.payload.map(elem => elem.humanPriceKei ?? 0).reduce(sum)
            self.shiharaiKingakuShukei = data.payload.map(elem => elem.shiharaiKingakuKei ?? 0).reduce(sum)
            self.genkaiRiekiShukei = data.payload.map(elem => elem.genkaiRieki ?? 0).reduce(sum)
            self.riekiRateShukei = Math.round(10000 * self.genkaiRiekiShukei / (self.jishaUriageShukei + self.yoshaUriageShukei)) / 100
          }

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var loginEigyoshoId = 0
            if (self.eigyoshoList) {
              const loginEigyosho = self.eigyoshoList.filter((elem) => {
                return elem.eigyoshoCd === self.loginEigyoshoCd
              })
              if (loginEigyosho.length !== 0) {
                loginEigyoshoId = loginEigyosho[0].id
              }
            }
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            const startYmdString = `${startDate.getFullYear()}/${('0' + (startDate.getMonth() + 1)).slice(-2)}/${('0' + (startDate.getDate())).slice(-2)}`
            const endYmdString = `${endDate.getFullYear()}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${('0' + (endDate.getDate())).slice(-2)}`
            self.conditions = {
              searchEigyoshoId: loginEigyoshoId,
              ninushiId: null,
              seikyuYoteiStartYmd: startYmdString,
              seikyuYoteiEndYmd: endYmdString
            }
            self.jishaUriageShukei = 0
            self.yoshaUriageShukei = 0
            self.enginePriceShukei = 0
            self.hiwayPriceShukei = 0
            self.humanPriceShukei = 0
            self.shiharaiKingakuShukei = 0
            self.genkaiRiekiShukei = 0
            self.riekiRateShukei = 0
            self.searchText = ''
            self.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient.post('/api/v1/VwCThbzmd0040/download', this.conditions).then((data) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        this.isCsvDownloader = false
        elem.href = window.URL.createObjectURL(blob)
        elem.click()
      })
    },
    onPdfButtonClick: function (e) {
      this.isPdfDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCThbzmd0040/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          this.isPdfDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    searchValidate: function () {
      return true
    }
  }
}
